import AxiosAPI from '@qualitas/libs';
import { AxiosResponse } from 'axios';

import { TaxHolder } from '../Models';

export const TaxHoldersAPI = (baseURL: string | undefined, clientId: string) => {
    const api = AxiosAPI({
        baseURL,
        clientId,
        isApp: true,
        hasUnderMaintenance: false
    });

    const getTaxHolders = (ContractId: number) => {
        const serviceUrl = `/bookbuilding-api/TaxHolder/GetTaxHolder`;
        return api.get(serviceUrl, { params: { ContractId } })
            .then((response: AxiosResponse) => response.data)
            .catch((error: any) => error);
    };

    const saveTaxHolders = (data: TaxHolder[]) => {
        const serviceUrl = `/bookbuilding-api/TaxHolder/SaveTaxHolder`;
        return api.post(serviceUrl, data)
            .then((response: AxiosResponse) => response.data)
            .catch((error: any) => error);
    };
    const updateTaxHolders = (data: TaxHolder[]) => {
        const serviceUrl = `/bookbuilding-api/TaxHolder/UpdateTaxHolder`;
        return api.put(serviceUrl, data)
            .then((response: AxiosResponse) => response.data)
            .catch((error: any) => error);
    };

	const deleteTaxHolders = (taxHolder: number) => {
        const serviceUrl = `/bookbuilding-api/TaxHolder/DeleteTaxHolder`;
        return api.delete(serviceUrl, {params: { id: taxHolder }})
            .then((response: AxiosResponse) => response.data)
            .catch((error: any) => error);
    };

    return {
		getTaxHolders,
		saveTaxHolders,
		updateTaxHolders,
		deleteTaxHolders
	};
};
